import { Skeleton } from '@eika/skeleton';
import { useNextStep } from '@react-query/hooks/query/use-next-step';
import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import './next-step.scss';

export const NextStep = () => {
    const { processId } = useParams();
    const navigate = useNavigate();
    const { data: nextStepUrl, isPending, error } = useNextStep();

    useEffect(() => {
        if (!processId) {
            // Redirect to overview if no process ID
            navigate('/', { replace: true });
            return;
        }

        if (error || isPending) {
            return;
        }

        if (nextStepUrl) {
            // External redirect
            if (nextStepUrl.startsWith('http')) {
                window.location.href = nextStepUrl;
                return;
            }

            // Internal redirect
            navigate(nextStepUrl, { replace: true });
        }
    }, [processId, nextStepUrl, isPending, error, navigate]);

    if (isPending) {
        return <NextStepSkeleton />;
    }

    if (error) {
        // TODO: Error screen
        return <div>Noe gikk galt!</div>;
    }

    return null;
};

const NextStepSkeleton = () => (
    <div className="next-step-skeleton" data-testid="next-step-skeleton">
        <Skeleton width="100%" height="6rem" />
        <Skeleton width="100%" height="3rem" />
        <Skeleton width="100%" height="3rem" />
    </div>
);
